import React from "react";
import { Phone, AlertCircle } from "lucide-react";
import { PRIMARY_PHONE } from "@/lib/site";

export const EmergencyBanner = () => {
  return (
    <section
      data-testid="emergency-banner"
      className="relative overflow-hidden bg-[var(--color-primary)] text-white"
    >
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-10 lg:py-14">
        <div className="flex flex-col lg:flex-row items-start lg:items-center justify-between gap-6">
          <div className="flex items-start gap-4">
            <div className="grid h-12 w-12 place-items-center rounded-full bg-[var(--color-secondary)] shrink-0">
              <AlertCircle className="h-6 w-6 text-white" />
            </div>
            <div>
              <p className="text-xs uppercase tracking-[0.2em] text-amber-300 font-bold">
                Emergency? We're already on the way
              </p>
              <h3 className="font-display text-2xl sm:text-3xl font-extrabold leading-tight mt-1">
                Stuck on the side of the road in Victoria?
              </h3>
              <p className="mt-1 text-blue-100 max-w-xl">
                Call us 24/7 — most jobs dispatched within minutes. Towing from{" "}
                <span className="font-num font-bold text-white">$70</span>.
              </p>
            </div>
          </div>
          <a
            href={`tel:${PRIMARY_PHONE.tel}`}
            data-testid="emergency-banner-call-button"
            className="inline-flex items-center gap-3 rounded-full bg-white px-6 py-4 text-[var(--color-primary)] font-display font-extrabold text-lg shadow-lg hover:-translate-y-0.5 hover:shadow-xl transition-all"
          >
            <Phone className="h-5 w-5" />
            <span className="font-num">{PRIMARY_PHONE.number}</span>
          </a>
        </div>
      </div>
    </section>
  );
};

export default EmergencyBanner;
